import React from 'react'
import { BoxProps, Flex } from '@chakra-ui/react'
import { gql } from '@urql/core'
import { useMutation } from 'urql'
import useMe from 'hooks/useMe'
import { useBlogId } from 'containers/blogs/hooks'
import { ButtonLike } from 'components/button/ButtonLike'

export const MUTATION_LIKE_BLOG = gql<{ upvote_blog: boolean }, { id: string }>`
    mutation upvote_blog($id: String!) {
        upvote_blog(id: $id)
    }
`

export const LikeBlog = ({
    likes: initialLikes = 1,
    ...boxProps
}: { likes: number } & BoxProps) => {
    const me = useMe()
    const blogId = useBlogId()
    const [state, likeBlog] = useMutation(MUTATION_LIKE_BLOG)
    const [likes, setLikes] = React.useState(initialLikes)

    const handleClick = () => {
        if (me) {
            likeBlog({ id: blogId }).then(
                res => res.data?.upvote_blog && setLikes(n => n + 1),
            )
        }
    }

    return (
        <Flex
            alignItems="center"
            gridGap="16px"
            fontWeight="600"
            fontSize="16px"
            color="text.500"
            {...boxProps}
        >
            Did you like this article?{' '}
            <ButtonLike
                likes={likes}
                handleClick={handleClick}
                isLiked={likes !== initialLikes}
                isDisabled={state.fetching}
            />
        </Flex>
    )
}
